import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thankyou',
  templateUrl: './thankyou.component.html',
  styleUrls: ['./thankyou.component.scss']
})
export class ThankyouPage implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/thankyou/thankyou.component.ts